import api from './api';

export interface UserSettings {
  soleTrader: boolean;
}

export const userSettingsApi = {
  get: async (): Promise<UserSettings> => {
    const response = await api.get('/user-settings');
    return response.data.data;
  },

  update: async (settings: Partial<UserSettings>): Promise<UserSettings> => {
    const response = await api.put('/user-settings', settings);
    return response.data.data;
  },
};







